<template>
	<div>
		<div class="grid grid-cols-12 gap-6">

			<div class="col-span-12 lg:col-span-3 xxl:col-span-2 flex lg:block flex-col-reverse">
				<div class="intro-y box lg:mt-0 pb-5">
					
					<div class="relative flex items-center p-5">
						<div class="font-medium text-base">
							<BoxIcon class="w-6 h-6 mr-1"/>{{ $t('App') }}
						</div>
						<div class="absolute right-0 top-0 mr-5 mt-5" v-if="userIsRoot">
							<PlusCircleIcon class="w-6 h-6 text-gray-600 dark:text-gray-300 cursor-pointer" title="Nuevo Bloque" @click="showCreateView = true"/>
						</div>
					</div>

					<div class="border-t border-gray-200 dark:border-dark-5 pt-2">

						<!-- Create View --> 
						<div v-if="showCreateView" class="pb-2 px-3">
							<form ref="newViewRef" class="validate-form" @submit.prevent="addView(currentTab.id, $event)">
								<input type="text" name="view" class="form-control" placeholder="Nombre" required  />
								<button type="submit" class="btn btn-sm btn-secondary w-full mt-2">{{ $t('Add Block') }}</button>
							</form>
						</div>

						<!-- View menu --> 
						<div v-for="(tab) in currentViews" :key="tab.id">
							<a class="flex items-center cursor-pointer py-2 px-5 border-b border-gray-200 dark:border-dark-5"
								:class="getTabClass(tab)"
								@click="selectView(tab.id)" v-if="Object.keys(tab.params).length !== 0">
								<component :is="tab.icon" class="w-4 h-4 mr-2" /> {{ tab.name }}
							</a>
						</div>

					</div>

				</div>
			</div>

			<div v-if="currentTab" class="intro-y box col-span-12 lg:col-span-9 xxl:col-span-8">

				<div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5">
					<h2 class="font-medium text-base mr-auto"><component :is="currentTab.icon" class="w-6 h-6 mr-2"  />{{ currentTab.name }}</h2>
					<div v-if="userIsRoot" class="dropdown ml-auto">
						<a class="dropdown-toggle w-5 h-5 block" href="javascript:;" aria-expanded="false"><MoreHorizontalIcon class="w-5 h-5 text-gray-600 dark:text-gray-300" /></a>
						<div class="dropdown-menu w-52">
							<div class="dropdown-menu__content box dark:bg-dark-1 p-2">
								<a @click="showModal('modalAttr' + currentTab.id)" class="flex items-center p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md cursor-pointer">
									<PlusIcon class="w-4 h-4 mr-2" />{{ $t('New attribute') }}
								</a>
								<a @click="showModal('modalDeleteView' + currentTab.id)" class="flex items-center p-2 transition duration-300 bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md cursor-pointer">
									<TrashIcon class="w-4 h-4 mr-2" />{{ $t('Delete view') }}
								</a>
							</div>
						</div>
					</div>
				</div>

				<div id="form-validation" class="p-5">
					<div class="preview">
						
						<form :id="currentTab.id" :ref="'form-' + currentTab.id" class="validate-form" @submit.prevent="updateView($event)">
							
							<div v-for="(param, key) in currentTab.params" :key="param">

								<!-- Map -->  
								<div v-if="$helper.isObject(param)">

									<!-- Map > Array -->
									<div v-if="Object.entries(param)[0] && $helper.isObject(Object.entries(param)[0][1])">
										<div v-for="(p, k) in param" :key="p">  
											<div v-if="$helper.isObject(p)">
												<div class="form-inline mb-2">  
													<label class="form-label w-40 font-medium">{{ key }} / {{ k }} <span class="hidden">{{ setOptions(key) }}</span></label>
													<div class="input-form mb-3 w-full">
														<TailSelect
															:id="key"
															:name="k"
															ref="TailSelectRef"
															:options="{
																search: true,
																descriptions: true,
																hideSelected: true,
																hideDisabled: true,
																multiSelectAll: true,
																multiShowCount: true,
																multiContainer: true,
																locale: 'es',
																classNames: 'w-full',
															}"
															multiple
														>
															<option :value="pp" v-for="(pp) in p" :key="pp" selected>{{ pp }}</option>
															<option :value="o.id" v-for="(o) in selOptions" :key="o.id">{{ o.title }}</option>
														</TailSelect>
													</div>
												</div>
											</div>
										</div>
									</div>

									<!-- Array -->
									<div v-else class="form-inline mb-2">
									
										<label class="form-label w-40 font-medium">{{ key }}</label>

										<div class="grid grid-cols-12 gap-2">

											<div class="col-span-12" v-for="(p, k) in param" :key="p">
												
												<div class="grid grid-cols-12 gap-2">
													<div class="col-span-3 align-middle">
														<input type="text" disabled class="form-control" :value="k">
													</div>
													<input type="text" class="form-control col-span-8" :id="key" :value="p" :name="k" />
													<div class="col-span-1">
														<XIcon class="mt-2 w-4 h-4 cursor-pointer" @click="showModal('delete-array-item-' + key + '-' + k + '-' + currentTab.id)" />
													</div>
												</div>

												<!-- Delete Array item -->
												<div :id="'delete-array-item-' + key + '-' + k + '-' + currentTab.id" class="modal" tabindex="-1" aria-hidden="true">
													<div class="modal-dialog">
														<div class="modal-content">
															<div class="modal-body p-0">
																<div class="p-5 text-center">
																	<XCircleIcon class="w-16 h-16 text-theme-24 mx-auto mt-3" />
																	<div class="text-2xl mt-5">{{ $t('Delete Record') }}</div>
																	<div class="text-gray-600 mt-2">{{ "(" + k + ") " + p }}</div>
																	<div class="text-gray-600 mt-2">
																		{{ $t('Are you sure you want to delete the record?') }} <br />
																		{{ $t('This action is irreversible') }}.
																	</div>
																</div>
																<div class="px-5 pb-8 text-center">
																	<button type="button" data-dismiss="modal" class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1">
																		{{ $t('Cancel') }}
																	</button>
																	<button type="button" class="btn btn-danger w-24" @click="deleteAttribute(key, currentTab.id, k)">
																		{{ $t('Delete') }}
																	</button>
																</div>
															</div>
														</div>
													</div>
												</div>

											</div>

											<!-- <div class="col-span-12">
												<div class="input-form mb-3">
													<div class="grid grid-cols-12 gap-2">
														<div class="col-span-3 align-middle">
															<input type="text" class="form-control" placeholder="ID" @input="setNewArrayID($event)">
														</div>
														<input class="form-control col-span-8"
															type="text"
															:id="NewArrayID ? key : ''"
															:name="NewArrayID != '' ? NewArrayID : ''"
															:required="NewArrayID ? true : false"
															placeholder="Valor"/>
													</div>
												</div>
											</div> -->

										</div>
										
									</div>

								</div>

								<!-- Boolean -->
								<div v-else-if="typeof param === 'boolean'">
									<!-- Boolean --> 
									<div class="form-inline mb-5">  
										<label :for="key" class="form-label w-32 font-medium">{{ key }}</label>
										<input :id="key" class="form-check-switch" type="checkbox" :checked="param" />
										<XIcon class="mt-0 ml-2 w-4 h-4 cursor-pointer" @click="showModal('delete-view-attribute-' + key + '-' + currentTab.id)" />
									</div>
								</div>

								<!-- Icon | String -->
								<div v-else>
									
									<div class="form-inline mb-5" v-if="key == 'icon'">
										<label class="form-label w-40 font-medium text-left">{{ key }}</label>
										<select :id="key" class="form-select cursor-pointer">
											<option :value="icon" v-for="(icon, key) in currentIcons" :key="key" :selected="icon == param">{{ icon }}</option>
										</select>
									</div>

									<div class="form-inline mb-5" v-else>
										<label :for="key" class="form-label w-32 font-medium">{{ key }}</label>
										<input type="text" class="form-control" :id="key" :value="param" />
										<XIcon
											class="mt-0 ml-2 w-4 h-4 cursor-pointer"
											@click="showModal('delete-view-attribute-' + key + '-' + currentTab.id)"
											v-if="key != 'title'"
										/>
									</div> 

								</div>

								<!-- Delete Attribute -->  
								<div :id="'delete-view-attribute-' + key + '-' + currentTab.id" class="modal" tabindex="-1" aria-hidden="true">
									<div class="modal-dialog">
										<div class="modal-content">
											<div class="modal-body p-0">
												<div class="p-5 text-center">
													<XCircleIcon class="w-16 h-16 text-theme-24 mx-auto mt-3" />
													<div class="text-xl mt-5">{{ $t('Delete settings parameter') }}</div>
													<div class="text-red-600 mt-2">{{ currentTab.id + " > " + key }}</div>
													<div class="text-gray-600 mt-2">
														{{ $t('Are you sure you want to delete?') }} <br />
														{{ $t('This action is irreversible') }}.
													</div>
												</div>
												<div class="px-5 pb-8 text-center">
													<button type="button" data-dismiss="modal" class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1">
														{{ $t('Cancel') }}
													</button>
													<button type="button" class="btn btn-danger w-24" @click="deleteAttribute(key, currentTab.id)">
														{{ $t('Delete') }}
													</button>
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>

							<div class="input-form pt-5 border-t border-gray-200 dark:border-dark-5 mt-5">
								<button type="submit" class="btn btn-primary">{{ $t('Save') }}</button>
							</div>

						</form>

						<!-- Reset datasets -->
						<div class="mt-5" v-if="currentTab.id && currentTab.id == 'firebase'">
							<div class="intro-y box mt-5 lg:mt-0 cursor-pointer">
								<div class="col-span-12 mt-6">
									<div class="ads-box box p-5 relative overflow-hidden intro-y">
										<div class="ads-box__title w-full text-theme-17 dark:text-white text-base -mt-3">{{ $t('Database') }} </div>
										<div>{{ $t('Datasets, images, models, sessions and events') }}</div>
										<div class="mt-5">
											<button class="btn btn-danger" @click="resetDatasets()">{{ $t('Reset') }}</button>
										</div>
										<img class="hidden sm:block absolute top-0 right-0 w-40 mt-12 -mr-8 opacity-40" :alt="$t('Documentation')" :src="require(`@/assets/images/logo/rphelp.png`)" />
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

				<!-- New attribute Modal --> 
				<div :id="'modalAttr' + currentTab.id" class="modal" tabindex="-1" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">

							<div class="modal-body p-10">
								
								{{ currentTab.name }}<br>
								<div class="text-center mb-3">{{ $t('New configuration parameter') }}</div>	
								{{ $t('Attribute type') }}:<br>
								
								<form id="formAttr" class="validate-form" @submit.prevent="saveAttribute($event)" ref="formAttr">

									<input type="hidden" name="tabID" :value="currentTab.id">

									<select name="AttType" class="form-select mt-2 sm:mr-2 cursor-pointer" @change="onChangeAtt($event)">
										<option value="string">String</option>
										<option value="boolean">Boolean</option>
										<option value="icon">Icon</option>
										<!-- <option value="array">Array</option> -->
									</select>

									<div class="mt-3" v-if="AttType!='icon'">
										<input name="AttName" type="text" required class="form-control" :placeholder="$t('Name')" />
									</div>

									<div class="mt-3" v-if="AttType=='string'">
										<input name="AttValue" required type="text" class="form-control" :placeholder="$t('Default value')" />
									</div>

									<div class="mt-3" v-if="AttType=='boolean'">
										<select name="AttValue" class="form-select cursor-pointer">
											<option value="true">{{ $t('Yes') }}</option>
											<option value="false">{{ $t('No') }}</option>
										</select>
									</div>

									<div class="mt-3" v-if="AttType=='icon'">
										<input name="AttName" type="text" required class="form-control" :placeholder="$t('Name')" value="icon" />
										<select name="AttValue" class="form-select cursor-pointer mt-2">
											<option :value="icon" v-for="(icon, key) in currentIcons" :key="key">{{ icon }}</option>
										</select>
									</div>

									<button type="submit" class="btn btn-primary mt-5">{{ $t('Add Attribute') }}</button>
									<button :id="'close-modalAttr'+currentTab.id" type="button" data-dismiss="modal" class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1">{{ $t('Cancel') }}</button>

								</form>

							</div>
						</div>
					</div>
				</div>

				<!-- Delete view Modal --> 
				<div :id="'modalDeleteView' + currentTab.id" class="modal" tabindex="-1" aria-hidden="true">
					<div class="modal-dialog">
						<div class="modal-content">
							<div class="modal-body p-0">
								<div class="p-5 text-center">
									<XCircleIcon class="w-16 h-16 text-theme-24 mx-auto mt-3" />
									<div class="text-xl mt-5">{{ $t('Deleting view') }}</div>
									<div class="text-red-600 mt-2 text-2xl">{{ currentTab.name }}</div>
									<div class="text-red-600 mt-2 font-medium">{{ $t('You will lose all the parameters it contains') }}</div>
									<div class="text-gray-600 mt-2">{{ $t('No') }} <br />{{ $t('This action is irreversible') }}.</div>
								</div>
								<div class="px-5 pb-8 text-center">
									<button type="button" data-dismiss="modal" class="btn btn-outline-secondary w-24 dark:border-dark-5 dark:text-gray-300 mr-1">{{ $t('Cancel') }}</button>
									<button type="button" class="btn btn-danger w-24" @click="deleteView(currentTab.id)">{{ $t('Delete') }}</button>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script setup>
import { onMounted, ref, computed } from "vue";
import { useStore } 				from "@/store";
import { helper as $helper } 		from "@/utils/helper";
import cash 						from "cash-dom";

import * as rosepetalModel  		from "rosepetal-model";

let $dataset   	= rosepetalModel.default.dataset;
let $event  	= rosepetalModel.default.event;
let $ui     	= rosepetalModel.default.ui;
let $user   	= rosepetalModel.default.user;

const props = defineProps({
	tab: {
		type: String,
		default: 'tags',
	}
});

const userRole = computed(() => {
	return useStore().state.main.User.role && useStore().state.main.User.role.role_id;
});

const userIsRoot = computed(() => {
	return userRole.value == 3;
});

const currentViews		= ref([]);
const currentTab		= ref({});
const currentIcons		= ref([]);

const showCreateView	= ref(false);
const AttType     		= ref('string');
const NewArrayID  		= ref(false);
const selOptions  		= ref([]);

const showModal			= (modal) => { AttType.value = "string"; cash("#" + modal).modal("show"); };
const onChangeAtt		= (event) => { AttType.value = event.target.value };
const setNewArrayID		= (event) => { NewArrayID.value = event.target.value };

const newViewRef		= ref(null);
const formAttr 			= ref(null);

const initialize = async (tab = false) => {
	currentViews.value = await $ui.get();
	currentTab.value = currentViews.value.find(view => view.id === tab) || currentViews.value[0];
	currentIcons.value = $helper.getIcons();
}

const reload = async () => {
	currentViews.value = await $ui.get();
	currentTab.value = currentViews.value.find(view => view.id === currentTab.value.id) || currentViews.value[0];
}

const selectView = async (viewID) => {
	currentTab.value = viewID ? currentViews.value.find(view => view.id === viewID) : currentViews.value[0];
}

const isTabVisible = (tab) => {
  if (!tab.params.role) return true;
  return userRole.value && tab.params.role.includes(userRole.value);
}

const getTabClass = (tab) => {
	if (!isTabVisible(tab)) return 'hidden';
	return tab.id === currentTab.value.id ? 'dark:text-white text-theme-12 font-medium' : '';
}

const setOptions = async (k) => { 
	if (k == "roles") {
		let users = await $user.list();
		for (const [k,u] of Object.entries(users)) {
			if ( k >= 0 && u.email) {
				selOptions.value.push({ id: u.email , title: u.email });
			}
		}
	}
}

const resetDatasets = async () => {
	if (confirm("Are you sure you want to reset the database?")){
		if (confirm("All datasets, images, models, sessions and events will be deleted. Continue?")) {
			if (confirm("This action is irreversible. Are you sure?")) {
				await $dataset.resetDatasets();
				alert("The reset process has started, you will be able to see the changes on your dashboard once it is finished.");
			}
		}
	}
}

const addView = async () => {
	if (!newViewRef.value.length) return;

	const viewInput = Array.from(newViewRef.value).find(el => el.name === 'view');
	if (!viewInput || !viewInput.value.trim()) return;

	const viewName = viewInput.value.trim().replace(/\s+/g, '').toLowerCase();
	const view = { value: viewName };

	await $ui.add(view, 'New configuration block created');

	await $event.saveEvent('app.view.add', {
		uid: useStore().state.main.User.uid,
		created: viewName
	}, false);

	await reload();
	selectView(viewName);

	showCreateView.value = false;
}

const updateView = async (event) => {
	if (event) event.preventDefault();

	const form = event.target;
	const data = {};

	for (const element of form.elements) {
		if (!element.id || element.type === 'submit') continue;

		if (element.type === 'select-multiple') {
			const selectedValues = Array.from(element.options)
				.filter(option => option.selected)
				.map(option => option.value);

			data[element.id] = {
				[element.name]: selectedValues,
			};
			continue;
		}

		if (element.name) {
			if (!data[element.id]) data[element.id] = {};
			data[element.id][element.name] = element.type === 'checkbox' ? element.checked : element.value;
		} else {
			data[element.id] = element.type === 'checkbox' ? element.checked : element.value;
		}
	}

	await $ui.update(form.id, data, 'Updated configuration');
	await $event.saveEvent(
		'app.view.update',
		{ uid: useStore().state.main.User.uid, updated: data },
		false
	);

	selectView(form.id);
}

const deleteView = async (viewID, event) => {
	if (event) event.preventDefault();

	await $ui.delete(viewID, 'Configuration view removed');

	await $event.saveEvent('app.view.delete', { 
		uid: useStore().state.main.User.uid, 
		deleted: viewID }, 
	false);

	cash('#modalDeleteView' + viewID).modal("hide");
	cash('#modalDeleteView' + viewID).removeClass('show');

	await reload();
}

const saveAttribute = async (event) => {
    if (event) event.preventDefault();

    if (!formAttr.value.length) return;

    const data = Array.from(formAttr.value).reduce((acc, el) => {
        if (el.type === 'submit') return acc;

        switch (el.name) {
            case 'AttType':
                acc.AttType = el.value;
                break;
            case 'tabID':
                acc.Collection = el.value;
                break;
            case 'AttName':
                acc.AttName = el.value.replace(/\s+/g, '').toLowerCase();
                break;
            case 'AttValue':
                acc.AttValue = el.value;
                break;
        }
        return acc;
    }, {});

    const { Collection, AttType, AttName, AttValue } = data;

    // Cambiamos la condición para permitir arrays
    if (Collection && AttType && AttName) {
        let newValue;
        if (AttType === 'boolean') {
            newValue = AttValue === 'true';
        } else if (AttType === 'array') {
            newValue = []; // Array vacío por defecto
        } else {
            newValue = AttValue;
        }

        const newAttr = { [AttName]: newValue };

        await $ui.updateAttr(Collection, newAttr, 'New configuration parameter created');
        
        await $event.saveEvent('app.view.add.attribute', {
            uid: useStore().state.main.User.uid,
            created: newAttr
        }, false);

        cash('#modalAttr' + currentTab.value.id).modal("hide");
        cash('#modalAttr' + currentTab.value.id).removeClass('show');

        await reload();
    }
}

const deleteAttribute = async (key, tab, name = null) => {
	const modalId = name
		? `#delete-array-item-${key}-${name}-${tab}`
		: `#delete-view-attribute-${key}-${tab}`;

	const modal = cash(modalId);
	modal.modal("hide");
	modal.removeClass("show");

	await $ui.deleteAttr(tab, key, name, 'Attribute removed');

	await $event.saveEvent('app.view.delete.attribute', {
		uid: useStore().state.main.User.uid,
		view: tab,
		deleted: key,
		...(name && { attribute: name })
	}, false);

	await reload();
}

onMounted( async () => { 
	await initialize(props.tab);
});
</script>